export const locale = {
  lang: 'zh2',
  data: {
    'CHANGELOG': {
      'TITULO': '变更日志',
      'SUBTITULO': '随着时间的推移检查对平台所做的更新',
      'ULTIMA': '最后更新',
      'CATEGORIAS': {
        'Changed': '更新',
        'Fixed': '修复',
        'Added': '改进'
      }
    },
    'KNOWLEDGE': {
      'LINK': '如果平台没有自动重定向您，请单击此链接'
    }
  }
};
